import { isEmpty } from 'ramda'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import config from '@/config'
import SuiteInfo from '@/features/Listing/suite-info'
import LandlordPaymentHistory from '@/features/Payments/landlord-payment-history'
import { getLandlordPaymentReceipt } from '@/models/payment/ports'
import { DefaultButtonBar } from '@/components/button-bar'
import { Button } from '@/components/button'

const Wrapper = styled.div`
  height: 100%;
`

const InnerWrapper = styled.div`
  height: 100%;
`

const TenantPayment = ({
  match: {
    params: { listingId, paymentId }
  },
  history
}) => {
  const { t } = useTranslation()
  const [paymentData, setPaymentData] = useState({})

  useEffect(() => {
    const loadPaymentData = async () => {
      const { body } = await getLandlordPaymentReceipt({
        paymentRequestId: paymentId
      })
      setPaymentData(body)
    }
    if (paymentId) {
      loadPaymentData()
    }
  }, [paymentId])

  if (!paymentData || isEmpty(paymentData)) return null

  const pdfUrl = `${config.BACKEND_SERVER}/payment_request/receipt/landlord/${paymentId}/receipt.pdf`

  return (
    <Wrapper>
      <Helmet>
        <title>{t('b.payments.view.payments.title', 'Payments')}</title>
      </Helmet>
      <InnerWrapper>
        <SuiteInfo listingId={listingId} />
        <LandlordPaymentHistory paymentData={paymentData} history={history} />
      </InnerWrapper>
      <DefaultButtonBar>
        {paymentData?.state_machine_cycle === 'complete' && (
          <Button theme="primary" size="small" href={pdfUrl}>
            {t('b.payment.view.export_payment_receipt.button', 'Export')}
          </Button>
        )}
      </DefaultButtonBar>
    </Wrapper>
  )
}

export default TenantPayment
